import { render, staticRenderFns } from "./lin-table.vue?vue&type=template&id=83cc0e60&scoped=true&"
import script from "./lin-table.vue?vue&type=script&lang=js&"
export * from "./lin-table.vue?vue&type=script&lang=js&"
import style0 from "./lin-table.vue?vue&type=style&index=0&id=83cc0e60&lang=scss&scoped=true&"
import style1 from "./lin-table.vue?vue&type=style&index=1&lang=css&"
import style2 from "./lin-table.vue?vue&type=style&index=2&id=83cc0e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cc0e60",
  null
  
)

export default component.exports